<template>
  <b id="modalSerialNumber">
    <div class="content-serialNumber">
    <p class="title" >Cadastrar número de série</p>
    <b-row>
      <!-- <b-col sm=2 class="device-serialNumber">
        <img src="../../assets/svg/cel-imei.svg" alt=""/>
      </b-col> -->
      <b-col sm=10>
        <p class="instrucao-serialNumber">
         1. O número de série deve estar listado após a palavra "número de série", "SSN", "S / N", ou "SN”.<br/><br/>
         2. Você poderá localiza-lo na nota fiscal, no aparelho, ou em uma etiqueta colada no aparelho.
        </p>
      </b-col>
      <b-col>
        <v-text-field
          label="Digite número de série*"
          ref="serialNumber"
          :rules="[
            () => !!serialNumber || 'Por favor, preencha esse campo',
            () => serialNumber.length >= 4 || 'Preencha o campo corretamente',
            () => serialNumber.length >= 45 && 'Preencha o campo corretamente',
            () => serialNumberValido || mensagemSerialNumber
          ]"
          required
          v-model="serialNumber"
        ></v-text-field>
        <Button
          class="quero-proteger"
          @click="postSerialNumber()"
          :disabled="(serialNumber.length > 45 || serialNumber.length < 4) && !this.checkButton"
          label="Cadastrar número de série"
          theme="purple"
        />
      </b-col>
    </b-row>
  </div>
  </b>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'

  import Button from '@/components/ui/Button'

  export default {
    name: 'SerialNumberRegistration',
    props: {
      policy: String,
      onSuccess: {
        type: Function,
        default: () => {}
      }
    },
    components: {
      Button
    },
    data () {
      return {
        serialNumber: '',
        userUuid: '',
        Uuid: '',
        checkButton: false,
        serialNumberValido: true,
        mensagemSerialNumber: ''
      }
    },
    computed: {
      ...mapState(['device'])
    },
    mounted () {
      if (this.$route.query.id) {
        this.$store.state.device.payment = {
          planUuid: this.$route.query.id
        }
      }
    },
    methods: {
      postSerialNumber () {
        window.dataLayer.push({
          event: 'dispositivos-ciclic',
          categoria: 'cadastro-dispositivo',
          acao: 'nuemro-serie',
          rotulo: 'enviar'
        })

        axios
        .patch(`${process.env.VUE_APP_API_URL}/internal-cell-phones/v1/policy/serialnumber`, {
          'uuid': this.device.payment.planUuid,
          'serialNumber': this.serialNumber
        }, JSON.parse(sessionStorage.config))
        .then((response) => {
          this.checkButton = false
          this.serialNumberValido = true
          this.$emit('confirmDeviceIdentification', true)
          this.$bvModal.hide('modalDeviceIdentification')
          this.$bvModal.show('MODAL_SUCESSO')
          if (this.onSuccess) {
            this.onSuccess()
          }
        }).catch((error) => {
          console.log(error.response.data)
          const status = error.status || error.response.data.status || error.response.data[0].status
          if (status === 400) {
            this.mensagemSerialNumber = 'Número de série inválido'
          } else if (error.response.data.status === 404) {
            this.mensagemSerialNumber = 'Ocorreu um erro. Por favor tente novamente'
          } else {
            this.mensagemSerialNumber = 'Ocorreu um erro. Por favor tente novamente'
            this.$sentry.logWithContext({
              ctx: '[serialnumber]', error
            })
          }
          this.checkButton = true
          this.serialNumberValido = false
          this.$refs.serialNumber.validate(true)
          // Limpa para futuras validações do serialNumber
          this.serialNumberValido = true
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  #modalDeviceIdentification {
    .title {
      font-family: Oscine;
      font-size: 32px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.19;
      letter-spacing: normal;
      color: #324b68;
    }

    .device-serialNumber {
      text-align: center;
    }

    .instrucao-serialNumber {
      font-family: Rubik;
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #324b68;

      span {
        font-weight: 700;
      }
    }

    .quero-proteger {
      height: 50px;
      margin: 10px auto 0;
      max-width: 400px;
    }
  }
</style>
